import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';
import ToastCustom from '../components/toast';

const EditProductPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [variants, setVariants] = useState([]);
  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getProduct.php?id=${id}`);
        const data = await response.json();
        console.log('Fetched product:', data); // Debugging line
        setProduct(data);
        setVariants(data.variants || []); // Ensure variants are set
      } catch (error) {
        console.error('Error fetching product:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const updatedProduct = {
      ...product,
      variants,
    };

    try {
      const response = await fetch('https://app.mirzawaleed.com/updateProduct.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedProduct),
      });
      const result = await response.json();
      setToastMessage(result.message);

      if (result.success) {
        setTimeout(() => {
          console.log("Product updated");
        }, 2000);
      }
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  const handleVariantChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);
  };

  const handleAddVariant = () => {
    setVariants([...variants, { name: '', quantity: 0 }]);
  };

  const handleRemoveVariant = (index) => {
    setVariants(variants.filter((_, i) => i !== index));
  };

  if (loading) return <p>Loading...</p>;
  if (!product) return <p>No product found.</p>;

  return (
    <>
      <Header />
      <div style={{ padding: '80px 20px 20px 20px' }}>
        <h1>Edit Product</h1>
        <form onSubmit={handleUpdate}>
          <div style={inputGroupStyle}>
            <label>Product Name</label>
            <input
              type="text"
              value={product.name}
              onChange={(e) => setProduct({ ...product, name: e.target.value })}
              required
            />
          </div>
          <div style={inputGroupStyle}>
            <label>Price</label>
            <input
              type="number"
              value={product.price}
              onChange={(e) => setProduct({ ...product, price: e.target.value })}
              required
            />
          </div>

          {variants.length > 0 ? (
            variants.map((variant, index) => (
              <div key={index} style={variantRowStyle}>
                <div style={inputGroupStyle}>
                  <label>Variant Name</label>
                  <input
                    type="text"
                    value={variant.name}
                    onChange={(e) => handleVariantChange(index, 'name', e.target.value)}
                    required
                  />
                </div>
                <div style={inputGroupStyle}>
                  <label>Quantity</label>
                  <input
                    type="number"
                    value={variant.quantity}
                    onChange={(e) => handleVariantChange(index, 'quantity', e.target.value)}
                    required
                  />
                </div>
                <button type="button" onClick={() => handleRemoveVariant(index)} style={deleteButtonStyle}>
                  Delete
                </button>
              </div>
            ))
          ) : (
            <div style={inputGroupStyle}>
              <label>Quantity</label>
              <input
                type="number"
                value={product.quantity}
                onChange={(e) => setProduct({ ...product, quantity: e.target.value })}
                required
              />
            </div>
          )}

          <button type="button" onClick={handleAddVariant} style={addVariantButtonStyle}>
            Add Variant
          </button>

          <button type="submit" style={updateButtonStyle}>
            Update
          </button>
        </form>
      </div>
      <Footer />

      {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}
    </>
  );
};

const inputGroupStyle = {
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
};

const variantRowStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '10px',
};

const deleteButtonStyle = {
  marginLeft: '10px',
  padding: '5px 10px',
  backgroundColor: '#F44336',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

const addVariantButtonStyle = {
  marginTop: '20px',
  padding: '10px',
  backgroundColor: '#2196F3',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

const updateButtonStyle = {
  marginTop: '20px',
  padding: '10px',
  backgroundColor: '#4CAF50',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

export default EditProductPage;
